<template>
    <!-- <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.68004 1.94462L4.95888 0.184616C2.07021 2.43692 0.168506 5.90769 0 9.84615H2.40722C2.49291 8.28541 2.92157 6.76449 3.66132 5.3965C4.40108 4.0285 5.43289 2.84863 6.68004 1.94462ZM21.5928 9.84615H24C23.8195 5.90769 21.9178 2.43692 19.0411 0.184616L17.332 1.94462C18.5738 2.85307 19.601 4.03425 20.3383 5.40151C21.0756 6.76877 21.5042 8.28744 21.5928 9.84615ZM19.2217 10.4615C19.2217 6.68308 17.2477 3.52 13.8054 2.68308V1.84615C13.8054 0.824615 12.999 0 12 0C11.001 0 10.1946 0.824615 10.1946 1.84615V2.68308C6.74022 3.52 4.77834 6.67077 4.77834 10.4615V16.6154L2.37111 19.0769V20.3077H21.6289V19.0769L19.2217 16.6154V10.4615ZM12 24C12.1685 24 12.325 23.9877 12.4814 23.9508C13.2638 23.7785 13.9017 23.2369 14.2146 22.4985C14.335 22.2031 14.3952 21.8831 14.3952 21.5385H9.58074C9.59278 22.8923 10.664 24 12 24Z"
            fill="currentColor"
        />
    </svg> -->
    <!-- <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.2706 18.7692V19.6154C15.2706 20.513 14.9261 21.3739 14.3128 22.0087C13.6996 22.6434 12.8679 23 12.0006 23C11.1334 23 10.3016 22.6434 9.6884 22.0087C9.07517 21.3739 8.73066 20.513 8.73066 19.6154V18.7692M20.7723 17.0468C19.4602 15.3846 18.5339 14.5385 18.5339 9.95601C18.5339 5.75962 16.4636 4.26457 14.7596 3.53846C14.5333 3.44221 14.3202 3.22115 14.2513 2.98053C13.9524 1.9276 13.1144 1 12.0006 1C10.8868 1 10.0483 1.92813 9.75252 2.98159C9.68354 3.22486 9.47048 3.44221 9.24414 3.53846C7.53814 4.26563 5.4699 5.75538 5.4699 9.95601C5.46734 14.5385 4.54103 15.3846 3.22896 17.0468C2.68533 17.7353 3.16151 18.7692 4.11236 18.7692H19.894C20.8397 18.7692 21.3128 17.7322 20.7723 17.0468Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg> -->
    <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.2706 18.7692V19.6154C15.2706 20.513 14.9261 21.3739 14.3128 22.0087C13.6996 22.6434 12.8679 23 12.0006 23C11.1334 23 10.3016 22.6434 9.6884 22.0087C9.07517 21.3739 8.73066 20.513 8.73066 19.6154V18.7692M20.7723 17.0468C19.4602 15.3846 18.5339 14.5385 18.5339 9.95601C18.5339 5.75962 16.4636 4.26457 14.7596 3.53846C14.5333 3.44221 14.3202 3.22115 14.2513 2.98053C13.9524 1.9276 13.1144 1 12.0006 1C10.8868 1 10.0483 1.92813 9.75252 2.98159C9.68354 3.22486 9.47048 3.44221 9.24414 3.53846C7.53814 4.26563 5.4699 5.75538 5.4699 9.95601C5.46734 14.5385 4.54103 15.3846 3.22896 17.0468C2.68533 17.7353 3.16151 18.7692 4.11236 18.7692H19.894C20.8397 18.7692 21.3128 17.7322 20.7723 17.0468Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
